import tIUrlClickData from './TIUrlClickData';

const operations: { [key: string]: any } = {
    TIUrlClickData: tIUrlClickData,
};

export default operations;
